import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-close.tsx
/**
* icon.16.close
*
* Keywords: cross, x, dismiss, delete, cancel, remove, negative, multiplication
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTEuMTQ2IDQuMTQ2YS41LjUgMCAwIDEgLjcwNy43MDdMOC43MDggOGwzLjE0NiAzLjE0NmEuNS41IDAgMCAxLS43MDcuNzA3TDggOC43MDhsLTMuMTQ3IDMuMTQ2YS41LjUgMCAwIDEtLjcwNy0uNzA3TDcuMjkzIDggNC4xNDYgNC44NTNhLjUuNSAwIDEgMSAuNzA3LS43MDdMOCA3LjI5M3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11914
*/
const Icon16Close = memo(function Icon16Close(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M11.146 4.146a.5.5 0 0 1 .707.707L8.708 8l3.146 3.146a.5.5 0 0 1-.707.707L8 8.708l-3.147 3.146a.5.5 0 0 1-.707-.707L7.293 8 4.146 4.853a.5.5 0 1 1 .707-.707L8 7.293z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16Close };

//# sourceMappingURL=icon-16-close.js.map